import {
  APIPermissionProfilePreset,
  type APIPermissionProfilePresetResponseType,
  type APIPermissionProfilePresetUsageResponseType,
} from "@/core/data_sources/models/APIPermissionProfilePreset";
import { State } from "@/core/data_sources/store/state";

export type PermissionProfilePresetsStateType = {
  list: APIPermissionProfilePreset[];
  selected: APIPermissionProfilePreset | null;
  usage: APIPermissionProfilePresetUsageResponseType | null;
};

export class PermissionProfilePresetsState extends State<PermissionProfilePresetsStateType> {
  constructor() {
    super({ list: [], selected: null, usage: null });
  }

  setPresets(presets: APIPermissionProfilePresetResponseType[]) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, usage: null }),
      list: presets.map((preset) => new APIPermissionProfilePreset(preset)),
    });
  }

  setSelected(preset: APIPermissionProfilePresetResponseType | null) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, usage: null }),
      selected: preset ? new APIPermissionProfilePreset(preset) : null,
    });
  }

  setUsage(usage: APIPermissionProfilePresetUsageResponseType | null) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], selected: null, usage: null }),
      usage,
    });
  }

  clear(): void {
    this._observable.next({ list: [], selected: null, usage: null });
  }
}
